// Dashboards
import CallStats from 'pages/dashboards/callStats';

// Accounts
import Admins from 'pages/accounts/admins/Index';
import Permissions from 'pages/accounts/permissions/Index';
import PermissionsSetsEdit from 'pages/accounts/permissions/PermissionsSetsEdit';

import { UsersRoutes } from '@/routes/users/index.routes';

// Automation
import { Jobs, Triggers } from 'pages/automation';
import TriggersEdit from 'pages/automation/triggers/new/TriggersEdit';
import EnginesRoutes from '@/routes/engines/index.routes';

// Billing
import PlansRoutes from '@/routes/plans/index.routes';
import { InternationalRatesList, Invoices } from 'pages/billing/';
import CSVInternationalRates from 'pages/billing/internationalRates/csv';

// Organisations
import { Companies, Partners, WholesalerIndex } from 'pages/organisations/';
import Addresses from 'pages/organisations/addresses';

// Services
import ServiceRoutes from 'pages/services/new/routes/index.routes';
import ServiceDashboardPage from 'pages/dashboards/v5/ServiceDashboardPage';
import OldServiceDashboardPage from 'pages/dashboards/v5/old/ServiceDashboardPage';
import ServiceProfiles from 'pages/services/serviceprofiles/new';

// Approval codes
import ApprovalCodes from 'pages/automation/approval-codes';

// Telephony
import { Calls, NumberBlocks, Regions, Trunks } from 'pages/telephony';
import CarriersRoutes from '@/routes/carriers/index.routes';
import TrunkTypesRoutes from '@/routes/trunkTypes/index.routes';
import VoicePoliciesRoutes from '@/routes/voicePolicies/index.routes';
import SpecialNumbersRoutes from '@/routes/specialNumbers/index.routes';
import TemplatesRoutes from '@/routes/templates/index.routes';
import ServiceCategoriesRoutes from '@/routes/serviceCategories/index.routes';
import CountriesRoutes from '@/routes/countries/index.routes';
import RegionAdd from 'pages/telephony/regionsAndLocations/regions/RegionAdd';
import RegionEdit from 'pages/telephony/regionsAndLocations/regions/RegionEdit';
import LocationAdd from 'pages/telephony/regionsAndLocations/locations/LocationAdd';
import LocationEdit from 'pages/telephony/regionsAndLocations/locations/LocationEdit';

// Settings
import ProtectedNoMatch from 'components/v4/ProtectedNoMatch';
import AutoAttendantGuide from 'pages/accounts/users/guides/AutoAttendantGuide';
import VirtualUserGuide from 'pages/accounts/users/guides/VirtualUserGuide';
import Reload from 'pages/reload';
import Settings from 'pages/settings';
import CSVNumbersUpdate from 'pages/telephony/numbers/csv';
import CSVNumberBlocksUpdate from 'pages/telephony/numberBlocks/csv';
import OrderDetailsPage from 'pages/telephony/numberBlocks/orders/OrderDetailsPage';
import AdminsCreate from 'pages/accounts/admins/adminUsers/new/AdminsCreate';
import AdminsEdit from 'pages/accounts/admins/adminUsers/new/AdminsEdit';
import AddTrunk from 'pages/telephony/trunks/new/AddTrunk';
import EditDRTrunk from 'pages/telephony/trunks/new/EditDRTrunk';
import EditExtTrunk from 'pages/telephony/trunks/new/EditExtTrunk';
import EditOCTrunk from 'pages/telephony/trunks/new/EditOCTrunk';
import EditSipTrunk from 'pages/telephony/trunks/new/EditSipTrunk';
import EditEightByEightTrunk from 'pages/telephony/trunks/new/EditEightByEightTrunk';
import EditACSrunk from 'pages/telephony/trunks/new/EditACSrunk';
import EditWebexTrunk from 'pages/telephony/trunks/new/EditWebexTrunk';
import EditOperatorPlatformTrunk from 'pages/telephony/trunks/new/EditOperatorPlatformTrunk';
import EditGCCHTrunk from 'pages/telephony/trunks/new/EditGCCHTrunk';
import EditSRTTrunk from 'pages/telephony/trunks/new/EditSRTTrunk';

// new organisations
import { CompanyAdd } from 'pages/organisations/companies/new/CompanyAdd';
import CompanyTable from 'pages/organisations/companies/new/Index';

import { ServicesDashboardProvider } from 'context/ServicesDashboardContext';
import ApiUserCreate from 'pages/accounts/admins/apiUsers/create/ApiUserCreate';
import ApiUserEdit from 'pages/accounts/admins/apiUsers/edit/ApiUserEdit';

// Settings Sidebar
import NumbersRoutesNew from '@/routes/numbers/index2.routes';
import VisibilityGroupsRoutes from '@/routes/visibilityGroups/index.routes';
import Preferences from 'pages/settingsSidebar/preferences/Index';
import Security from 'pages/settingsSidebar/security/Index';
import EditZoomTrunk from 'pages/telephony/trunks/new/EditZoomTrunk';
import Audit from 'pages/audit';
import CSVAddressUpdate from 'pages/organisations/addresses/csv';
import { Pex } from 'pages/accounts';

// TRS Clusters
import TRSClusters from 'pages/ga/trs-clusters/Index';
import TRSClustersAdd from 'pages/ga/trs-clusters/Add';
import TRSClustersEdit from 'pages/ga/trs-clusters/Edit';

// TRS Registration (AORs)
import AORsIndex from 'pages/resources/aors/Index';
import AORsAdd from 'pages/resources/aors/Add';
import AORsEdit from 'pages/resources/aors/Edit';
import AORsCSVUpdate from 'pages/resources/aors/csv/csvRegistrationForm';

// TRS Nodes
import TRSNodes from 'pages/ga/trs-nodes/Index';
import TRSNodesAdd from 'pages/ga/trs-nodes/Add';
import TRSNodesEdit from 'pages/ga/trs-nodes/Edit';

// Registrars (PBX)
import Registrars from 'pages/resources/pbx/Index';
import RegistrarsAdd from 'pages/resources/pbx/Add';
import RegistrarsEdit from 'pages/resources/pbx/Edit';

// TRS Feature Disabled Page
import VisibilityGroupsErrorPage from 'pages/organisations/visibility-groups-error-page';
import OperatorServices from 'pages/services/operatorPlatformServices/OperatorServices';
// import RegistrarAssignmentsIndex from 'pages/resources/pbx/AssignmentsIndex';
// import RegistrarsIpRange from 'pages/resources/pbx/IpRanges';

import CustomSIPHeadersIndex from 'pages/telephony/customSIPheaders/Index';
import ServiceProvidersIndex from 'pages/ga/serviceProviders/index';
import EightByEightCatalogIndex from 'pages/ga/eightByEightCatalog/index';
import SiteManagementIndex from 'pages/services/eightByEight/siteManagement/index';

import DialPlansRoutes from '@/routes/dialPlans/index.routes';
import OCProfilesRoutes from '@/routes/ocProfiles/index.routes';

/**
 * @param {import('@tanstack/react-query').QueryClient} [queryClient]
 * @returns {import('react-router-dom').RouteObject[]}
 */
// eslint-disable-next-line no-unused-vars
const authenticatedRoutes = (queryClient = {}) => [
    // Other
    { path: '*', element: <ProtectedNoMatch /> },
    { path: '/settings', element: <Settings />, hidden: true },
    {
        path: '/numbers/csv-numbers',
        element: <CSVNumbersUpdate />,
        hidden: true,
    },
    {
        path: '/number-blocks/csv',
        element: <CSVNumberBlocksUpdate />,
        hidden: true,
    },
    { path: '/virtualuserguide', element: <VirtualUserGuide />, hidden: true },
    { path: '/guide', element: <AutoAttendantGuide />, hidden: true },
    { path: '/reload/*', element: <Reload />, hidden: true },
    // Dashboards
    {
        path: '/dashboard-services',
        element: (
            <ServicesDashboardProvider>
                <OldServiceDashboardPage />
            </ServicesDashboardProvider>
        ),
    },
    // (2635) The new dashboard. Once it replaces the old one, it moves to
    // /dashboard-services and pages/dashboards/v5/old is deleted.
    {
        path: '/dashboard-services/new',
        element: (
            <ServicesDashboardProvider>
                <ServiceDashboardPage />
            </ServicesDashboardProvider>
        ),
    },
    {
        path: '/call-stats',
        element: <CallStats />,
    },
    // Accounts
    {
        path: '/admins',
        element: <Admins />,
    },
    {
        path: '/pex-import',
        element: <Pex />,
    },
    { path: '/admins/create', element: <AdminsCreate /> },
    {
        path: '/admins/:adminId/edit',
        element: <AdminsEdit />,
    },
    {
        path: '/admins/api/',
        element: <ApiUserCreate />,
    },
    {
        path: '/admins/api/:apiUserId/edit',
        element: <ApiUserEdit />,
    },
    {
        path: '/permissions',
        element: <Permissions />,
    },
    {
        path: '/admins/permissions/:permissionSetId/edit',
        element: <PermissionsSetsEdit />,
    },
    {
        path: '/users/*',
        element: <UsersRoutes />,
    },
    // Automation
    {
        // No route needed for API
    },
    {
        element: <Triggers />,
        path: '/triggers',
    },
    {
        path: '/triggers/create',
        element: <TriggersEdit />,
    },
    {
        path: '/triggers/:triggerId/edit',
        element: <TriggersEdit />,
    },
    { element: <Jobs />, path: '/jobs' },
    { element: <ApprovalCodes />, path: '/approval-codes' },
    // Billing
    {
        path: '/international-rates',
        element: <InternationalRatesList />,
    },
    {
        path: '/international-rates/csv',
        element: <CSVInternationalRates />,
        hidden: true,
    },
    {
        path: '/invoices',
        element: <Invoices />,
    },
    {
        path: '/plans/*',
        element: <PlansRoutes />,
    },
    // {
    //     path: '/plans',
    //     element: <Plans />,
    // },
    // Organisations
    {
        path: '/new/companies',
        element: <CompanyTable />,
    },
    {
        path: '/new/companies/add',
        element: <CompanyAdd />,
    },
    {
        path: '/companies',
        element: <Companies />,
    },
    {
        path: '/partners',
        element: <Partners />,
    },
    {
        path: '/addresses/csv-address',
        element: <CSVAddressUpdate />,
        hidden: true,
    },
    {
        path: '/addresses',
        element: <Addresses />,
    },
    {
        path: '/service-profiles',
        element: <ServiceProfiles />,
    },
    {
        path: '/visibility-groups/*',
        id: 'visibility-groups',
        children: [...VisibilityGroupsRoutes(queryClient)],
        errorElement: <VisibilityGroupsErrorPage />,
    },
    {
        path: '/services/*',
        element: <ServiceRoutes />,
    },
    // Telephony
    {
        path: '/calls',
        element: <Calls />,
    },
    {
        path: '/dial-plans/*',
        children: DialPlansRoutes,
    },

    {
        path: '/numbers/*',
        id: 'numbers',
        children: NumbersRoutesNew,
    },
    {
        path: '/number-blocks',
        element: <NumberBlocks />,
    },
    {
        path: '/number-blocks/orders/:orderId',
        element: <OrderDetailsPage />,
        hidden: true,
    },
    {
        path: '/trunks',
        element: <Trunks />,
    },
    {
        path: '/trunks/add',
        element: <AddTrunk />,
        errorElement: <Trunks />,
    },
    {
        path: '/trunks/edit/sip/:id',
        element: <EditSipTrunk />,
        errorElement: <Trunks />,
    },
    {
        path: '/trunks/edit/ext/:id',
        element: <EditExtTrunk />,
        errorElement: <Trunks />,
    },
    {
        path: '/trunks/edit/zoom/:id',
        element: <EditZoomTrunk />,
        errorElement: <Trunks />,
    },
    {
        path: '/trunks/edit/8x8/:id',
        element: <EditEightByEightTrunk />,
        errorElement: <Trunks />,
    },
    {
        path: '/trunks/edit/dr/:id',
        element: <EditDRTrunk />,
        errorElement: <Trunks />,
    },
    {
        path: '/trunks/edit/oc/:id',
        element: <EditOCTrunk />,
        errorElement: <Trunks />,
    },
    {
        path: '/trunks/edit/acs/:id',
        element: <EditACSrunk />,
        errorElement: <Trunks />,
    },
    {
        path: '/trunks/edit/webex/:id',
        element: <EditWebexTrunk />,
        errorElement: <Trunks />,
    },
    {
        path: '/trunks/edit/GCCH/:id',
        element: <EditGCCHTrunk />,
        errorElement: <Trunks />,
    },
    {
        path: '/trunks/edit/operator-platform/:id',
        element: <EditOperatorPlatformTrunk />,
        errorElement: <Trunks />,
    },
    {
        path: '/trunks/add/srt',
        element: <EditSRTTrunk />,
        errorElement: <Trunks />,
    },
    {
        path: '/trunks/edit/srt/:id',
        element: <EditSRTTrunk />,
        errorElement: <Trunks />,
    },
    {
        path: '/voice-policies/*',
        children: VoicePoliciesRoutes,
    },
    {
        path: '/audit',
        element: <Audit />,
    },
    // GA
    {
        path: '/templates/*',
        children: TemplatesRoutes,
    },
    {
        path: '/service-categories/*',
        children: ServiceCategoriesRoutes,
    },
    {
        path: '/engines/*',
        children: EnginesRoutes,
    },
    {
        path: '/wholesalers',
        element: <WholesalerIndex />,
    },
    {
        path: '/carriers/*',
        id: 'carriers',
        children: CarriersRoutes,
    },
    {
        path: '/regions-and-locations',
        element: <Regions />,
    },
    {
        path: '/regions-and-locations/regions/add',
        element: <RegionAdd />,
        hidden: true,
    },
    {
        path: '/regions-and-locations/regions/edit/:id',
        element: <RegionEdit />,
        hidden: true,
    },
    {
        path: '/regions-and-locations/locations/add',
        element: <LocationAdd />,
        hidden: true,
    },
    {
        path: '/regions-and-locations/locations/edit/:id',
        element: <LocationEdit />,
        hidden: true,
    },
    {
        path: '/countries/*',
        children: CountriesRoutes,
    },
    {
        path: '/special-numbers/*',
        children: SpecialNumbersRoutes,
    },
    {
        path: '/trunk-types/*',
        children: TrunkTypesRoutes,
    },
    {
        path: '/operator-connect-profiles/*',
        children: OCProfilesRoutes,
    },
    {
        path: '/operator-services',
        element: <OperatorServices />,
    },
    {
        path: '/custom-headers',
        element: <CustomSIPHeadersIndex />,
    },
    {
        path: '/security',
        element: <Security />,
    },
    {
        path: '/preferences',
        element: <Preferences />,
    },
    {
        path: '/trs-clusters',
        element: <TRSClusters />,
    },
    {
        path: '/trs-clusters/add',
        element: <TRSClustersAdd />,
        hidden: true,
    },
    {
        path: '/trs-clusters/edit/:id',
        element: <TRSClustersEdit />,
        hidden: true,
    },

    {
        path: '/aors',
        element: <AORsIndex />,
    },
    {
        path: '/aors/add',
        element: <AORsAdd />,
        hidden: true,
    },
    {
        path: '/aors/edit/:id',
        element: <AORsEdit />,
        hidden: true,
    },
    // NOTE: comment out csv for registrations until finish
    {
        path: '/aors/csv',
        element: <AORsCSVUpdate />,
        hidden: true,
    },
    // TRS Nodes routes
    {
        path: '/trs-nodes',
        element: <TRSNodes />,
    },
    {
        path: '/trs-nodes/add',
        element: <TRSNodesAdd />,
        hidden: true,
    },
    {
        path: '/trs-nodes/edit/:id',
        element: <TRSNodesEdit />,
        hidden: true,
    },

    // Registrars routes
    {
        path: '/pbx',
        element: <Registrars />,
    },
    {
        path: '/pbx/add',
        element: <RegistrarsAdd />,
        hidden: true,
    },
    {
        path: '/pbx/edit/:id',
        element: <RegistrarsEdit />,
        hidden: true,
    },

    // Service Providers routes
    {
        path: '/service-providers',
        element: <ServiceProvidersIndex />,
    },

    // 8x8 Catalog routes
    {
        path: '/8x8-catalog',
        element: <EightByEightCatalogIndex />,
    },

    // 8x8 Site Management
    {
        path: '/managed-sites',
        element: <SiteManagementIndex />,
    },

    // {
    //     path: '/pbx/ip-ranges',
    //     element: <RegistrarsIpRange />,
    //     hidden: true,
    // },
    // Comment this for now as using modal approach (ADO #618)
    // {
    //     path: '/pbx/assign/:id',
    //     element: <RegistrarAssignmentsIndex />,
    //     hidden: true,
    // },
];

export default authenticatedRoutes;
